<template>
<div id="index">
     <div class="keTitle">
            <div class="keTitleL">
                <img src="@/assets/images/2019_firefly_TerWeb/0/logo.png" alt="">
            </div>
            <div class="keTitleR">
                <img src="@/assets/images/2019_firefly_TerWeb/0/menu icon.png" alt="" @click="dcclick()">  
            </div>
            <div class="dropdown">
                    <div><span><a href="/">首页</a></span></div>
                    <div><span><a href="#">新闻</a></span></div>
                    <div><span><a href="http://dev.t-firefly.com/index.html">社区</a></span></div>
                    <div><span><a href="http://www.t-chip.com.cn/about.html?theme=pc">关于我们</a></span></div>
                    <div><span><a href="http://www.t-firefly.com/about/join.html">加入我们</a></span></div>
                    <div>
                        <img src="@/assets/images/2019_firefly_TerWeb/0/store icon.png" style="display: inline-block;margin-top:-1.15%;width:7%;">
                        <span><a href="https://store.t-firefly.com">商城</a></span>
                    </div>
            </div>
        </div> 
<!--效果html开始-->
        <full-page :options="options" ref="page">
            <div class="section">
<!-- 滚动页第一页 -->
                <div class="page page0 cur">
                    <div class="pagecen">
                        <div class="page0Title">
                            <img style="display:block;margin: 0 auto;width:100%;height:100%;" src="@/assets/images/2019_firefly_TerWeb/1/标题.png" alt="">
                        </div>
                        <!-- 了解更多 -->
                        <template>
                            <div class="page0KonwMore">
                                <img src="@/assets/images/2019_firefly_TerWeb/1/icon.png" alt="" @click="showModal">
                                    <a-modal 
                                        :width = "width"
                                        :centered="centered"
                                        :closable="closable"
                                        :footer="null"
                                        v-model="visible" 
                                        @ok="handleOk">
                                        <video style="width:100%" class="kwvideo" src="https://download.t-firefly.com/video/%E5%A4%A9%E5%90%AF%E7%A7%91%E6%8A%80%E7%AE%80%E4%BB%8B/%E5%85%AC%E5%8F%B8%E5%AE%A3%E4%BC%A0%E8%A7%86%E9%A2%91..mp4" controls poster="https://download.t-firefly.com/video/%E5%A4%A9%E5%90%AF%E7%A7%91%E6%8A%80%E7%AE%80%E4%BB%8B/bg.JPG"></video>
                                    </a-modal>
                                
                            </div>
                        </template>
                    </div>
                    <!-- 下面海浪排版 -->
                <div class="waveWrapper waveAnimation">
                    <div class="waveWrapperInner bgTop">
                    <div class="wave waveTop" >   
                    &nbsp;
                    </div>
                    </div>
                    <div class="waveWrapperInner bgMiddle">
                    <div class="wave waveMiddle">
                    </div>
                    </div>
                    <div class="waveWrapperInner bgBottom">
                    <div class="wave waveBottom" >
                    </div>
                    </div>
                </div>
                </div>
            </div>
<!-- 滚动页第二页 -->
            <div class="section">
                <div class="page page1">
                        <div class="page1Top"><h1>公司简介</h1></div>
                        <div class="page1Center">
                            <ul>
                                <li style="text-indent:2em;"><p>天启科技专注于开源智能硬件，人工智能，物<span></span></p></li>
                                <li><p>联网，数字音频产品的研发设计、生产和销售，同<span></span></p></li>
                                <li><p>时提供了智能软件产品的整体解决方案。 天启是<span></span></p></li>
                                <li><p>福州瑞芯电子(RockChip)正式授权的IDH（独立<span></span></p></li>
                                <li><p>设计公司) ， 同时也是瑞芯(RockChip)的战略合作<span></span></p></li>
                                <li><p>伙伴，与瑞芯电子有超过10年的紧密合作关系。<span></span></p></li>
                            </ul>
                        </div>
                        <div class="page1KnowMore">
                            <img src="@/assets/images/2019_firefly_TerWeb/2/组28.png" alt="" @click="click">
                            <h1 @click="click">点击了解更多</h1>
                        </div>
                        <div class="page1Bottom">
                            <div class="page1BottomImg"></div>
                        </div>
                </div>
            </div> 
<!-- 滚动页第三页 -->
            <div class="section">  
                <div class="page page2">
                    <div class="page2Img1">
                        <img src="@/assets/images/2019_firefly_TerWeb/3/1.png" alt="">
                    </div>
                    <div class="page2Img2">
                        <img src="@/assets/images/2019_firefly_TerWeb/3/2.png" alt="">
                    </div>
                    <div class="page2Img3">
                        <img src="@/assets/images/2019_firefly_TerWeb/3/3.png" alt="">
                    </div>
                    <div class="page2Img4">
                        <img src="@/assets/images/2019_firefly_TerWeb/3/4.png" alt="">
                    </div> 
                    <div class="page2Img5">
                        <img src="@/assets/images/2019_firefly_TerWeb/3/5.png" alt="">
                    </div>        
                    <div class="page2Img6">
                        <img src="@/assets/images/2019_firefly_TerWeb/3/6.png" alt="">
                    </div> 
                    <div class="page2Img7">
                        <img src="@/assets/images/2019_firefly_TerWeb/3/7.png" alt="">
                    </div>
                    <div class="page2Img8">
                        <img src="@/assets/images/2019_firefly_TerWeb/3/8.png" alt="">
                    </div>
                    <div class="page2Img9">
                        <img src="@/assets/images/2019_firefly_TerWeb/3/9.png" alt="">
                    </div>
                    <div class="page2Img10">
                        <img src="@/assets/images/2019_firefly_TerWeb/3/10.png" alt="">
                    </div>
                    <div class="openSource">
                        <h1>Firefly开源品牌</h1>
                        <div class="introduction">
                            <ul>
                                <li>Firefly开源团队是天启科技于2014年创立的开源团队，</li>
                                <li>致力于人工智能、智能软件、嵌入式开发、系统开发、</li>
                                <li>应用程序开发等研发，拥有开源系列商城</li>
                                <li>开源社区与网上商城。</li>
                            </ul>
                        </div>
                    </div>      
                </div>
            </div>
<!-- 滚动页第四页 -->
            <div class="section laster">
                <div class="page page3">
                    <div class="camera">
                        <img src="@/assets/images/2019_firefly_TerWeb/4/图层5.png" alt="">
                        <span>全景相机</span>
                    </div>
                    <div class="solution">
                        <div class="solutionTitle">
                            <p>数码电子产品解决方案</p>
                        </div>
                        <div class="solutionN">
                            <p>专注于TV、互动媒体、机顶盒、网络数字标牌等智能媒体产品的研发, 为客户提供易于部署、快速实施的整体解决方案。</p>
                        </div>
                    </div>
                    <div class="page3Bottom">
                        <div class="equipment">
                            <div class="Eleft">
                                <img src="@/assets/images/2019_firefly_TerWeb/4/图层6.png" alt="">
                                <span>流媒体播放器</span>
                            </div>
                            <div class="Ecenter">
                                <img src="@/assets/images/2019_firefly_TerWeb/4/图层7.png" alt="">
                                <span>媒体采集器</span>
                            </div>
                            <div class="Eright">
                                <img src="@/assets/images/2019_firefly_TerWeb/4/图层8.png" alt="">
                                <span>个人服务器</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
<!-- 滚动页第五页 -->
            <div class="section">
                <div class="page page4">
                <div class="page4Top">
                        <h1>公司荣誉</h1>
                        <div class="leftb"></div>
                        <div class="rightb"></div>
                        <div id="certify">
                            <div class="swiper-container">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide"><img src="@/assets/images/2019_firefly_TerWeb/5/组 (1).jpg" /></div>
                                    <div class="swiper-slide"><img src="@/assets/images/2019_firefly_TerWeb/5/组 (2).jpg" /></div>
                                    <div class="swiper-slide"><img src="@/assets/images/2019_firefly_TerWeb/5/组 (3).jpg" /></div>
                                    <div class="swiper-slide"><img src="@/assets/images/2019_firefly_TerWeb/5/组 (4).jpg" /></div>
                                    <div class="swiper-slide"><img src="@/assets/images/2019_firefly_TerWeb/5/组 (5).jpg" /></div>
                                    <div class="swiper-slide"><img src="@/assets/images/2019_firefly_TerWeb/5/组 (6).jpg" /></div>
                                    <div class="swiper-slide"><img src="@/assets/images/2019_firefly_TerWeb/5/组 (7).jpg" /></div>
                                    <div class="swiper-slide"><img src="@/assets/images/2019_firefly_TerWeb/5/组 (8).jpg" /></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="page4Bottom">
                        <h1>合作伙伴</h1>
                        <div class="page4BottomImg" >
                            <img src="@/assets/images/2019_firefly_TerWeb/5/LOGO.png" alt="">
                        </div>
                    </div>
                </div>
            </div>  
<!-- 滚动页第六页 --> 
            <div class="section">
                <div class=" page5" >
                    <div class="page5Top">
                        <h1>产品定制</h1>
                    </div>
                <template>
                    <a-form
                    id="pro-dz"
                    :form="form"
                    class="login-form"
                    @submit="handleSubmit"
                >
                    <a-form-item>
                    <a-input
                        v-decorator="[
                        'username',
                        { rules: [
                            { 
                                required: true, 
                                message: '请输入你的姓名' 
                            }
                            ] 
                        },
                        ]"
                        placeholder="姓名"
                    >
                    </a-input>
                    </a-form-item>
                    <a-form-item>
                    <a-input
                        v-decorator="[
                        'phone',
                        { rules: [
                            { 
                                required: true, 
                                message: '请输入你的电话号码' 
                            },
                            ] 
                        },
                        ]"
                        placeholder="电话"
                    >
                    </a-input>
                    </a-form-item>
                    <a-form-item>
                    <a-input
                        v-decorator="[
                        'email',
                        { rules: [
                                { 
                                    required: true, 
                                    message: '输入你的邮箱' 
                                },
                                {
                                    type: 'email',
                                    message: '请输入正确的邮箱格式',
                                },
                            ] 
                        },
                        ]"
                        type="email"
                        placeholder="邮箱"
                    >
                    </a-input>
                    </a-form-item>
                    <a-form-item>
                    <a-input
                        v-decorator="[
                        'company',
                        { rules: [
                            { 
                                required: true, 
                                message: '请输入你的公司' 
                            }
                            ] 
                        },
                        ]"
                        placeholder="公司"
                    >
                    </a-input>
                    </a-form-item>
                    <a-form-item>
                    <a-select
                        
                        v-decorator="[
                        'select',
                        //{ rules: [{ required: true, message: '请选择信息来源' }] },
                        ]"
                        placeholder="选择信息来源"
                    >
                        <a-select-option value="0">
                        线上(如：社区、微信、网站、视频)
                        </a-select-option>
                        <a-select-option value="1">
                        线下(如：展会、讲座、比赛)
                        </a-select-option>
                        <a-select-option value="2">
                        网络搜索
                        </a-select-option>
                        <a-select-option value="3">
                        媒体报道
                        </a-select-option>
                        <a-select-option value="4">
                        朋友推荐
                        </a-select-option>
                        <a-select-option value="5">
                        其他
                        </a-select-option>
                    </a-select>
                    </a-form-item>
                    <a-form-item>
                    <a-textarea
                        v-decorator="[
                        'content',
                        { rules: [
                            { 
                                required: true, 
                                message: '请输入详细内容' 
                            }
                            ] 
                        },
                        ]"
                    placeholder="详细内容"
                    />
                    </a-form-item>
                    <a-form-item
                    >
                    <a-input
                        v-decorator="[
                        'captcha',
                        { rules: [
                            { 
                                required: true, 
                                message: '验证码不能为空' 
                            }
                            ] 
                        },
                        ]"
                        placeholder="验证码"
                    >
                    </a-input>
                        <img :src="captchUrl" @click="reCap()">
                    </a-form-item>
                    <a-form-item>
                    <a-button type="primary" html-type="submit" class="login-form-button">
                        提交表格
                    </a-button>
                    </a-form-item>
                </a-form>
                </template>
                </div>
            <div class="footerss">
                <div class="footer page6 ">
                    <!-- <div class="ft1"><h1>网站导航</h1></div> -->
                    <div class="ft2"><h1><a href="http://www.t-chip.com.cn/about.html?theme=pc">关于我们</a></h1></div>
                    <div class="ft3"><h1><a href="http://www.t-firefly.com/about/join.html">关注我们</a></h1></div>
                    <div class="ft4"><h1>全国服务热线:<span>4001-511-533</span></h1></div>
                    <div class="ft5">
                        <p>Copyright 2014-2017,T-Chip.All Rightts Resvered.</p>
                        <p>天启智能科技 | 粤ICP备14022016号-2</p>
                    </div>
                </div>
            </div>
        </div>    
<!-- 滚动页第六页 --> 
        </full-page>
   
</div>
</template>
 
<script>
// 导入接口函数
import Swiper from 'swiper';
import "../assets/js/swiper.min.js"
const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 8 },
};
export default {
    name: '',
    data () {
        return {
            centered:true,
            visible: false,
            closable:false,
            width:"",
            dhhei:1,
            kr:1,
            options: {
                verticalCentered: false,
                afterLoad:this.afterLoad,
                scrollOverflow: true,
                scrollOverflowOptions:function(){
                    scrollY:false;
                },
                // anchors: ['slogan', 'introduct', 'brand', 'solution', 'honor', 'partner'],
                scrollBar: false,
                menu: '#menu',
                navigation: true,
                onLeave: function (index, direction) {
                   if(direction.index==2){
                        $(".page2").addClass("current");
                        $(".openSource").addClass("textAn");
                    }else{
                        $(".page2").removeClass("current");
                        $(".openSource").removeClass("textAn");
                    }
                    if(direction.index==3){
                        $(".camera").addClass("textAn");
                        $(".page3Bottom").addClass("textAn");
                    }else{
                        $(".camera").removeClass("textAn");
                        $(".page3Bottom").removeClass("textAn")
                    }
                },
            },
            captchUrl: null,
        }
    },
    created(){
        this.captchUrl = 'http://' + process.env.CAPTCP_ROOT + '/cooperation/index/captcha?time='
    },
    beforeCreate() {
        this.form = this.$form.createForm(this, { name: 'normal_login' });
    },
    methods: {
        handleSubmit(e) {
            e.preventDefault();
            this.form.validateFields((err, values) => {
                if (!err) {
                    console.log('Received values of form: ', values);
                    this.$api.post(
                        'api/index/tqcooperationsub', 
                        {
                            username:values.username,
                            phone:values.phone,
                            email:values.email,
                            company:values.company,
                            captcha:values.captcha,
                            content:values.content,
                            newsfrom: values.select,
                            type: 1
                        }, 
                        res => {
                            if(res.code==1){
                                // swal({   title: "提交成功!",   text: "我们会尽快的联系您!",   icon: "success",   button: "确定", });
                                this.$info({
                                    centered: true,
                                    width: '50%',
                                    title: '提交成功',
                                    content: '我们会尽快联系您！',
                                    onOk() {
                                        window.location.reload();
                                    },
                                });

                            }if(res.code==0){
                                // swal({   title: "验证码错误!",   text: "请重新输入验证码!",   icon: "error",   button: "确定", });
                                this.$error({
                                    centered: true,
                                    width: '50%',
                                    title: '提交失败',
                                    content: res.msg,
                                });

                                this.captchUrl = this.src='http://' + process.env.CAPTCP_ROOT + '/cooperation/index/captcha?time='+Math.random();
                            }
                        }
                    )
                }
            });
        },
        //验证码
        reCap: function (){
          this.captchUrl = this.src='http://' + process.env.CAPTCP_ROOT + '/cooperation/index/captcha?time='+Math.random()
        },
        //页面滑动
        click(){
            this.$refs.page.api.moveSectionDown()
        },
        //第一页视频弹出
        showModal() {
            this.visible = true
        },
        handleOk(e) {
            console.log(e);
            this.visible = false;
        },
        // 导航栏事件
        dcclick:function()
        {
            $(".dropdown").slideToggle();
                if(this.kr%2==0){
                    $(".keTitle").removeClass('heiAnIn');
                    $(".keTitle").addClass('heiAnOut');
                    $(".keTitle").height=this.dhhei+'px'
                    $(".keTitle").css({"height":"","background-color":"#000000","opacity":"0.6"});
                }else{
                    $(".keTitle").removeClass('heiAnOut');
                    $(".keTitle").addClass('heiAnIn');
                    $(".keTitle").css({"height":"100%","background-color":"#000000","opacity":"1"});
                    this.dhhei = $(".keTitle").height()
                }
                this.kr=this.kr+1
        },
        //第五页图片滑动事件
        // 初始化swiper
        _initSwiper(){
            var certifySwiper = new Swiper('#certify .swiper-container',{
            watchSlidesProgress: true,
            slidesPerView: 'auto',
            centeredSlides: true,
            loop: true,
            autoplay:true,
            loopedSlides: 3,
            autoplay: true,
	        on: {
	        	progress: function(progress) {
	        		for (var i = 0; i < this.slides.length; i++) {
                        var slide = this.slides.eq(i);
                        // console.log(slide);
                        var slideProgress = this.slides[i].progress;
                        // console.log(slideProgress);
	        			var modify = 1.6;
	        			if (Math.abs(slideProgress) > 1) {
	        				modify = (Math.abs(slideProgress) - 1) * -0.8 + 1;
	        			}
	        			var translate = slideProgress * modify *70 + 'px';
	        			var scale = 1 - Math.abs(slideProgress) /8;
                        var zIndex = 999 - Math.abs(Math.round(8 * slideProgress));
                        // console.log(translate);
	        			slide.transform('translateX(' + translate + ') scale(' + scale + ')');
	        			slide.css('zIndex', zIndex);
	        			slide.css('opacity', 1);
	        			if (Math.abs(slideProgress) > 3) {
	        				slide.css('opacity', 0);
	        			}
	        		}
	        	},
	        	setTransition: function(transition) {
	        		for (var i = 0; i < this.slides.length; i++) {
	        			var slide = this.slides.eq(i)
                        slide.transition(transition);
			        }
		        }
	        }
            }) 
        },
        // Hdhidden(){
        //    $('.iScrollVerticalScrollbar').css("display","none"); 
        // }
    },
    mounted(){
        this._initSwiper()
        // this.Hdhidden()
    },
    creat(){
       this.hd() 
    }
}
$(document).ready(
        function() {
            window.onload=function(){
                $('.iScrollVerticalScrollbar').css("display","none");
            }
    })
</script>
<style src="../assets/css/extends.css" scoped>
</style>


// WEBPACK FOOTER //
// src/components/Index.vue